import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M7.138 8.745Q16.955 8 23.968 8q7.019 0 16.893.746a5 5 0 0 1 4.591 4.423Q46 18.006 46 24q0 4.894-.365 9.016a7 7 0 0 1-6.476 6.365q-8.69.62-15.094.619-6.42 0-15.221-.622a7 7 0 0 1-6.48-6.365Q2 28.893 2 24q0-5.995.548-10.832a5 5 0 0 1 4.59-4.423m-1.65 2.775-.08.12-.019.026c-.025.038-.05.075-.039.054a1.84 1.84 0 0 0 .747 2.493l16.406 8.846a2.8 2.8 0 0 0 1.497.357l.038.001c.51.014.982-.101 1.46-.358l16.405-8.846a1.84 1.84 0 0 0 .747-2.493c.01.021-.014-.016-.039-.053l-.097-.144a3 3 0 0 0-1.804-.782Q30.904 10 23.968 10q-6.93 0-16.68.74a3 3 0 0 0-1.8.78m38.175 3.87q-.358.337-.81.583L26.446 24.82a4.8 4.8 0 0 1-2.446.598 4.8 4.8 0 0 1-2.446-.598L5.148 15.973a4 4 0 0 1-.81-.583Q4 19.327 4 24q0 4.807.357 8.836a5 5 0 0 0 4.628 4.547Q17.72 38 24.065 38q6.326 0 14.952-.614a5 5 0 0 0 4.626-4.546Q44 28.81 44 24q0-4.673-.337-8.61",
      clipRule: "evenodd"
    }
  )
);
var SvgMailOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MailOutlined_default = SvgMailOutlined;

export { MailOutlined_default as default };
